import { paramCase } from 'change-case';

export default {
  getStylesheet(stylemap, selector, omitAll = false) {
    let stylesheet = '';
    let propertyStyles;
    const breakpoints = Object.keys(stylemap).filter(el => el !== 'all');
    if (!omitAll) breakpoints.unshift('all');
    breakpoints.forEach(breakpoint => {
      propertyStyles = this.getStateVariantStyles(
        stylemap[breakpoint],
        selector
      );
      if (propertyStyles && breakpoint === 'all') {
        stylesheet += `
        ${propertyStyles}
        `;
      } else if (propertyStyles) {
        stylesheet += `
        @media ${breakpoint} {
          ${propertyStyles}
        }`;
      }
    });
    return stylesheet;
  },
  getStateVariantStyles(variants, selector) {
    let styles = '';
    for (const variant in variants) {
      const propertyStyles = this.getPropertyStyles(variants[variant]);
      if(!propertyStyles) continue;

      let selectorVariant = '';
      switch(variant) {
        case 'none': 
          selectorVariant = selector;
          break; 
        case 'Hover':
          selectorVariant = selector.split(',').map(selector => `${selector}:${variant.toLowerCase()},${selector}.gp-hover`).join(','); // for multiple selector
          break;
        case 'Active':
          selectorVariant = selector.split(',').map(selector => `${selector}:${variant.toLowerCase()},${selector}.gp-active`).join(','); // for multiple selector
          break;
        case 'Focus':
          selectorVariant = selector.split(',').map(selector => `${selector}:${variant.toLowerCase()},${selector}.gp-focus`).join(','); // for multiple selector
          break;
        default: 
          selectorVariant = selector;
      }
      styles += `
        ${selectorVariant} {
          ${propertyStyles}
      }`;
    }
    return styles;
  },
  getPropertyStyles(properties) {
    let styles = '';
    for (const property in properties) {
      if (properties[property] !== null)
        // styles += `
        // ${property.includes('webkit',0) ? '-' + paramCase(property) : 
        // paramCase(property)}: ${properties[property]};`;
        if(property.includes('webkit',0)){
          styles +=  `-${paramCase(property)}: ${properties[property]};`;
        }
        else if (property.includes('gp-bg',0)){
          styles +=  `--${paramCase(property)}: ${properties[property]};`;
        }
        else {
          styles +=  `${paramCase(property)}: ${properties[property]};`;
        }
        // ${paramCase(property)}: ${properties[property]};`;
    }
    return styles;
  }
};
